export default "__VITE_ASSET__406ee6ab__"